import React, { useEffect, useState, useRef } from 'react';
import './donor.scss';
import DonorHeaderComponent from './components/donorHeader/donorHeader';
import DonorsComponent from './components/donorsComponent/donorsComponent';
import DonorManagerAPI from '../../../services/donorAPI';
import { Toast } from 'primereact/toast';
import LoadingComponent from '../../../common/Loading';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { URL_PATHNAME } from '../../../utils/Utils';
import { formatStringToNumber } from '../../../utils/functionCommon';
import { withTranslation } from 'react-i18next';

const DonorPage = (props: any) => {
  const { t } = props;
  const navigate = useNavigate();
  const [donorDonations, setDonorDonations] = useState<any>(null);
  const toast = useRef(null);
  const token = window ? window.location.pathname.split('/')[2] : '';
  const [isLoading, setIsLoading] = useState(false);
  const [dataDonation, setDataDonation] = useState({
    donations: 0,
    currenciesDonation: 0,
    areasDonation: 0,
    activeSubscription: [],
    finishedSubscription: [],
  });
  const [isLoadingAction, setIsLoadingAction] = useState(false);

  const getDonorDonation = async () => {
    setIsLoading(true);
    try {
      const { data: donorData } = await DonorManagerAPI.getDonations(token);
      if (donorData === 'Session is expired!') {
        navigate(URL_PATHNAME.DONOR_PORTAL);
      }

      if (donorData) {
        setIsLoading(false);

        const formatOnceDonation =
          donorData && donorData.donations && Array.isArray(donorData.donations.once_donations)
            ? donorData.donations.once_donations.map((itemOnceDonation: any) => {
                return {
                  ...itemOnceDonation,
                  donation_money: formatStringToNumber(itemOnceDonation.donation_money),
                  area: formatStringToNumber(itemOnceDonation.area),
                  amount_kg_co2: formatStringToNumber(itemOnceDonation.amount_kg_co2),
                };
              })
            : [];

        const formatSubDonation =
          donorData && donorData.donations && Array.isArray(donorData.donations.subscription_donations)
            ? donorData.donations.subscription_donations.map((itemSubDonation: any) => {
                return {
                  ...itemSubDonation,
                  donation_money: formatStringToNumber(itemSubDonation.donation_money),
                  area: formatStringToNumber(itemSubDonation.area),
                  amount_kg_co2: formatStringToNumber(itemSubDonation.amount_kg_co2),
                  sub_donations:
                    Array.isArray(itemSubDonation.sub_donations) && itemSubDonation.sub_donations.length > 0
                      ? itemSubDonation.sub_donations.map((itemSubDonationSub: any) => {
                          return {
                            ...itemSubDonationSub,
                            donation_money: formatStringToNumber(itemSubDonationSub.donation_money),
                            area: formatStringToNumber(itemSubDonationSub.area),
                            amount_kg_co2: formatStringToNumber(itemSubDonationSub.amount_kg_co2),
                          };
                        })
                      : [],
                };
              })
            : [];

        const formatDonorDonation = {
          ...donorData,
          donations: {
            once_donations: formatOnceDonation,
            subscription_donations: formatSubDonation,
          },
        };
        const childSubDonation = formatSubDonation?.flatMap((donor: any) => donor.sub_donations);
        setDonorDonations(formatDonorDonation);

        const sumCo2DonationsOnce = _.sumBy(formatOnceDonation, 'amount_kg_co2');
        const sumCo2DonationsSubscription = _.sumBy(formatSubDonation, 'amount_kg_co2');

        const sumCo2DonationsChildSubscription = _.sumBy(childSubDonation, 'amount_kg_co2');

        const sumAreaDonationsOnce = _.sumBy(formatOnceDonation, 'area');
        const sumAreaDonationsSubscription = _.sumBy(formatSubDonation, 'area');

        const sumAreaDonationsChildSubscription = _.sumBy(childSubDonation, 'area');

        const activeSubs: any = _.sortBy(formatSubDonation.filter((item: any) => !item.finished_date) || [], 'payment_date').reverse();

        const finishSubs: any = _.sortBy(formatSubDonation.filter((item: any) => item.finished_date) || [], 'payment_date').reverse();

        const noOfOnceDonations = formatOnceDonation.length > 0 ? donorData.donations.once_donations.length : 0;
        const noOfParentDonations =
          formatSubDonation.length > 0 ? donorData.donations.subscription_donations.filter((item: any) => item.is_first_time === 1).length : 0;

        setDataDonation({
          donations: noOfOnceDonations + noOfParentDonations,
          currenciesDonation: (sumCo2DonationsOnce || 0) + (sumCo2DonationsSubscription || 0) + (sumCo2DonationsChildSubscription || 0),
          areasDonation: (sumAreaDonationsOnce || 0) + (sumAreaDonationsSubscription || 0) + (sumAreaDonationsChildSubscription || 0),
          activeSubscription: activeSubs || [],
          finishedSubscription: finishSubs || [],
        });
      }
    } catch (error) {
      setIsLoading(false);
      setDonorDonations(null);
    }
  };

  useEffect(() => {
    getDonorDonation();
  }, []);

  return (
    <div className={`donor-page`}>
      {isLoadingAction && (
        <div className="loading-overlay">
          <div className="loading-container">
            <div className="loading-icon"></div>
          </div>
        </div>
      )}
      {!isLoading && donorDonations && donorDonations.donations ? (
        <div className="donor-container">
          <div className="donor-header">
            <DonorHeaderComponent donorDonations={donorDonations} dataDonation={dataDonation} />
          </div>
          <div className="donor-content">
            <div className="donor-content-container">
              <div className="donors-once">
                <div className="donors-headeline">
                  <p>{t('single_donation')}</p>
                </div>
                <DonorsComponent
                  data={_.sortBy(donorDonations?.donations?.once_donations || [], 'payment_date').reverse() || []}
                  token={token}
                  subscription={false}
                />
              </div>
              <div className="donors-subscription">
                {dataDonation?.activeSubscription?.length > 0 && (
                  <div className="donors-headeline">
                    <p>{t('active_subscriptions')}</p>
                  </div>
                )}
                <div className="subscriptions-container">
                  <div className="subscription-year">
                    <DonorsComponent data={dataDonation?.activeSubscription || []} token={token} subscription={true} />
                  </div>
                </div>
              </div>
              <div className="donors-subscription">
                {dataDonation?.finishedSubscription.length > 0 ? (
                  <div className="subscription-year">
                    <div className="donors-headeline">
                      <p>{t('cancelled_subscriptions')}</p>
                    </div>
                    <div className="subscriptions-container">
                      <div className="subscription-year">
                        <DonorsComponent data={dataDonation?.finishedSubscription || []} token={token} subscription={true} />
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <Toast ref={toast} />
        </div>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
};

export default withTranslation('language')(DonorPage);
